export const CITY_COORDS = {
  "München": [48.1351, 11.582], "Augsburg": [48.3705, 10.8978], "Nürnberg": [49.4521, 11.0767],
  "Stuttgart": [48.7758, 9.1829], "Köln": [50.9375, 6.9603], "Düsseldorf": [51.2277, 6.7735],
  "Frankfurt": [50.1109, 8.6821], "Hamburg": [53.5511, 9.9937], "Berlin": [52.52, 13.405],
  "Leipzig": [51.3397, 12.3731], "Dresden": [51.0504, 13.7373], "Bremen": [53.0793, 8.8017],
  "Hannover": [52.3759, 9.732], "Dortmund": [51.5136, 7.4653], "Essen": [51.4556, 7.0116],
};

const PLZ2 = {
  "80": [48.14, 11.58], "81": [48.11, 11.60], "85": [48.25, 11.40], "86": [48.37, 10.90],
  "90": [49.45, 11.08], "70": [48.78, 9.18], "71": [48.70, 9.20], "60": [50.11, 8.68],
  "50": [50.94, 6.96], "51": [50.90, 7.00], "40": [51.23, 6.77], "20": [53.55, 9.99],
  "22": [53.60, 10.00], "10": [52.52, 13.40], "12": [52.50, 13.40], "13": [52.55, 13.35],
  "01": [51.05, 13.74], "04": [51.34, 12.37], "28": [53.08, 8.80], "30": [52.38, 9.73],
  "44": [51.51, 7.47], "45": [51.46, 7.01],
};
const PLZ1 = {
  "0": [51.05, 13.4], "1": [52.5, 13.4], "2": [53.3, 9.9], "3": [52.0, 9.7], "4": [51.5, 7.3],
  "5": [50.9, 7.0], "6": [50.0, 8.6], "7": [48.7, 9.1], "8": [48.2, 11.5], "9": [49.5, 11.0],
};

export function plzToCoords(plz) {
  if (!plz || plz.length < 2) return null;
  return PLZ2[plz.slice(0, 2)] || PLZ1[plz[0]] || null;
}

export function dist(a, b) {
  const R = 6371, toR = (x) => (x * Math.PI) / 180;
  const dLat = toR(b[0] - a[0]), dLon = toR(b[1] - a[1]);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toR(a[0])) * Math.cos(toR(b[0])) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}
